import React, { useEffect, useState } from 'react'

import { ReactComponent as CheckWhite } from '../../../Assets/checkWhite.svg'
import './style.css'

interface SelectorProps {
  type: 'checkbox' | 'radio' | 'switch'
  label?: string
  name?: string
  value?: string
  checked?: boolean
  indeterminate?: boolean
  className?: string
  disabled?: boolean
  onChange?: (checked: boolean, value: string) => void
}

const Selector = ({
  type,
  label,
  name,
  value,
  checked = false,
  indeterminate,
  className = '',
  disabled = false,
  onChange,
}: SelectorProps) => {
  const [isChecked, setIsChecked] = useState(false)

  const handleChangeInput = (e) => {
    e.stopPropagation()
    setIsChecked(!isChecked)
    onChange(!isChecked, value)
  }

  useEffect(() => {
    setIsChecked(indeterminate ? indeterminate : checked)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked])

  return (
    <>
      <label
        data-testid="SelectorBlock"
        htmlFor={name}
        className={`SelectorBlock item-center group inline-flex cursor-pointer px-24 py-12 text-left text-neutral-100 ${className}`}
      >
        <span
          className={`form-checkbox relative flex items-center justify-center p-2 ${
            type === 'radio' || type === 'switch' ? 'rounded-full' : 'rounded-sm'
          } ${type === 'switch' ? 'mt-1.5 h-16 w-7 bg-neutral-50' : 'mt-2 h-5 w-5'} mr-3 border ${
            disabled
              ? 'disabled:cursor-not-allowed'
              : type !== 'switch' && 'outline-4 outline-purple-200 group-hover:border-purple-100 group-focus:outline'
          } ${
            indeterminate
              ? 'bg-white'
              : isChecked
                ? disabled
                  ? 'border-neutral-50 bg-neutral-50'
                  : `${type !== 'radio' && 'bg-purple-100'} border-purple-100`
                : 'border-neutral-50'
          }`}
        >
          {type === 'checkbox' ? (
            indeterminate ? (
              <span className={`inline-flex h-3 w-3 ${disabled ? 'bg-neutral-50' : 'bg-purple-100'} `}></span>
            ) : (
              <CheckWhite />
            )
          ) : null}
          {type === 'radio' ? (
            <span
              className={`border-1 inline-flex h-3 w-3 border-collapse rounded-full border-white ${
                isChecked && 'bg-purple-100'
              } ${disabled && 'bg-neutral-50'}`}
            ></span>
          ) : null}
          {type === 'switch' ? (
            <span
              className={`border-1 absolute h-3 w-3 border-collapse rounded-full bg-white transition-transform ${
                isChecked ? 'translate-x-1.5' : 'left-2'
              } ${disabled && 'bg-neutral-50'}`}
            ></span>
          ) : null}
          <input
            aria-label="Input checkbox"
            type={type === 'switch' ? 'checkbox' : type}
            name={name}
            id={name}
            value={value}
            disabled={disabled}
            className="absolute -z-10 h-full w-full opacity-0"
            checked={isChecked}
            onChange={(e) => {
              handleChangeInput(e)
            }}
          />
        </span>
        {label && <span data-testid="labelElement" dangerouslySetInnerHTML={{ __html: label }}></span>}
      </label>
    </>
  )
}

export default Selector
